export const GS_TRIGGER = 'GS_TRIGGER';
export const growerSettlementTrigger = (input) => ({
    type: GS_TRIGGER,
    payload: input
});
